export const defaultPage = 0
export const defaultLimit = 50
export const defaultSort = 'change.created_at-desc'

export const changesSortOptions = [
  {
    label: 'sort-created-desc.v',
    value: 'change.created_at-desc',
  },
  {
    label: 'sort-created-asc.v',
    value: 'change.created_at-asc',
  },
  {
    label: 'sort-email-asc.v',
    value: 'change.user_email-asc',
  },
  {
    label: 'sort-email-desc.v',
    value: 'change.user_email-desc',
  },
  {
    label: 'sort-account-name-asc.v',
    value: 'account.account_holder-asc',
  },
  {
    label: 'sort-account-name-desc.v',
    value: 'account.account_holder-desc',
  },
  {
    label: 'sort-type-asc.v',
    value: 'change.type-asc',
  },
  {
    label: 'sort-type-desc.v',
    value: 'change.type-desc',
  },

  {
    label: 'sort-form-name-asc.v',
    value: 'change.relation_type-asc',
  },
  {
    label: 'sort-form-name-desc.v',
    value: 'change.relation_type-desc',
  },
]

export * from './selection-options.util'
export * from './create-relation-url.util'
